module.exports = new __parcel__URL__("blank-dark.2ba4c737.png").toString();